<template>
  <div class="choose">
    <div v-if="icon" class="font div_class" v-on:click="goChooseHtml"><span>支付筛选</span>
      <img v-bind:src="chooseIcon1" width="7">
    </div>
    <div v-else class="font div_class"><span>支付筛选</span>
      <img v-bind:src="chooseIcon2" width="7">
    </div>
    <div class="help div_class" @click="textVisibleFn"><img v-bind:src="helpIcon"></div>
    <mt-popup v-model="popupTextVisible" class="popupTextArea" popup-transition="popup-fade">
      <div v-for="(textItem,index) in textSlots" class="textItem" :key="index">
        <span v-text="textItem.textWord"></span>
      </div>
    </mt-popup>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        chooseIcon1: require('../common/image/triangle-1.png'),
        chooseIcon2: require('../common/image/triangle-2.png'),
        helpIcon: require('../common/image/question.png'),
        popupTextVisible: false,
        textSlots: [
          {
            textWord: '数据相关说明'
          },
          {
            textWord: '1、支付方式包含微信支付、支付宝支付、刷卡支付、现金支付、个人微信、个人支付宝、好哒支付、美团点评、会员消费、挂账月结、免费赠送、会员储值、代金券支付等，筛选中只显示商户已使用过的支付方式。'
          },
          {
            textWord: '2、支付来源包含pos机、扫码点餐、商家后台。'
          },
          {
            textWord: '（1）凡通过pos机收款的支付来源都属于pos机，例如，扫码点餐下单后用pos机刷卡支付来源属于pos机。'
          },
          {
            textWord: '（2）扫码点餐线上支付（线上支付宝或者微信）支付来源为扫码点餐。'
          },
          {
            textWord: '（3）商家后台指通过商家管理平台修改订单状态的订单，其来源为商家后台。'
          },
          {
            textWord: '3、若统计的是当天的数据则数据统计时间段为：凌晨00:00:00分到当天进入页面的时间的数据。'
          }
        ]
      }
    },
    props: ['icon'],
    // 在 methods 对象中定义方法
    methods: {
      // 筛选页面
      goChooseHtml() {
        this.$router.push({ path: '/choose' })
      },
      textVisibleFn() {
        this.popupTextVisible = true
      }
    },
    // 加载加完毕执行
    mounted() {
      // console.log(this.icon)
    }
  }
</script>

<style>
  .choose {
    width: 40%;
    display: inline-block;
  }
  .choose .div_class {
    width: auto;
    height: 0.9rem;
    line-height: 0.9rem;
    display: inline-block;
  }
  .choose .font {
    padding-left: 0.2rem;
  }
  .font span {
    height: 100%;
    color: #F74D47;
    margin-right: 0.14rem;
    display: inline-block;
  }
  .font img {
    width: 0.18rem;
    height: 0.18rem;
    display: inline-block;
    vertical-align: middle;
  }
  .choose .help {
    padding: 0 0.2rem;
  }
  .help img {
    width: 0.24rem;
    height: 0.24rem;
  }
  /* 帮助窗 */
  .popupTextArea{
    width: 6.4rem;
    height: 8.3rem;
    background-color: #ffffff;
    padding: 0.28rem 0.26rem;
    border-radius: 8px;
  }
  .textItem:first-child{
    text-align: center;
    margin-bottom:0.4rem;
    font-size: 0.28rem;
    font-weight: bold;
  }
  .textItem:not(:first-child){
    text-align: left;
    font-size: 0.26rem;
    color:#555555;
    line-height: 0.43rem;
  }
</style>


// WEBPACK FOOTER //
// src/components/chooseBtn.vue